import { TableBody as MuiTableBody } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { Children, Fragment, cloneElement, isValidElement } from 'react';

import theme from '../theme';
import TableRowSeparator from './TableRowSeparator';

const {
  colors: { tableRowOddBackgroundColor },
} = theme;

const TableBody = ({ children, ...props }) => {
  const { css } = useStyles();

  const newChildren = Children.map(children, (child, index) => {
    if (isValidElement(child)) {
      return cloneElement(child, {
        ...child.props,
        className: css({
          ...(index % 2 === 0 && {
            backgroundColor: tableRowOddBackgroundColor,
          }),
        }),
      });
    }

    return child;
  });

  return (
    <MuiTableBody {...props}>
      {Children.toArray(newChildren).map((child, index) => (
        <Fragment key={`row-${index}`}>
          {cloneElement(child)}
          <TableRowSeparator />
        </Fragment>
      ))}
    </MuiTableBody>
  );
};

TableBody.propTypes = {
  children: PropTypes.node,
};

export default TableBody;
